import {
  GET_DROPDOWN_USERS,
  OFFICE_USER_MENUS,
  GET_DSPUSER,
  GET_DSP_USERS_LIST,
  GET_DSP_USER_1,
  GET_DSP_USER_RETAILER,
  GET_ADMIN_USERS_1,
  GET_INVOICE_MENUS 
} from "../../admin-constants";

const initialState = {
  dropdown_officer_users: [],
  office_user_menus: [],
  dspUserList:[],
  childUserDetails:[],
  childRetailerUserDetails:[],
  adminuser:[],
  dspUser:[],
  invoice_menus: []
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_DROPDOWN_USERS: {
      return {
        ...state,
        dropdown_officer_users: payload,
      };
    }
    case OFFICE_USER_MENUS: {
      return {
        ...state,
        office_user_menus: payload,
      };
    }

            case GET_DSPUSER:
      return {
        ...state,
        dspUser: payload,
      };

        case GET_DSP_USERS_LIST: {
      return {
        ...state,
        dspUserList: payload,
      };
    }

    case GET_DSP_USER_1: {
      return {
        ...state,
        childUserDetails: payload,
      };
    }
    case GET_DSP_USER_RETAILER: {
      return {
        ...state,
        childRetailerUserDetails: payload,
      };
    }
    case GET_ADMIN_USERS_1: {
      return {
        ...state,
        adminuser: payload,
      };
    }

    case GET_INVOICE_MENUS:
      return {
    ...state,
    invoice_menus: action.payload,
  };




    default:
      return state;
  }
};

export default reducer;
